import { ComponentType } from "react"

import AspectRatiosPage from "./base/AspectRatiosPage.mdx"
import ColorsPage from "./base/ColorsPage.mdx"
import DarkModePage from "./base/DarkModePage.mdx"
import IconsPage from "./base/IconsPage.mdx"
import TypographyPage from "./base/TypographyPage.mdx"

import ButtonsPage from "./controls/ButtonsPage.mdx"
import DateFieldsPage from "./controls/DateFieldsPage.mdx"
import DropdownsPage from "./controls/DropdownsPage.mdx"
import FileFieldsPage from "./controls/FileFieldsPage.mdx"
import InputFieldsPage from "./controls/InputFieldsPage.mdx"
import NavigationPage from "./controls/NavigationPage.mdx"
import TabsPage from "./controls/TabsPage.mdx"
import TogglesPage from "./controls/TogglesPage.mdx"

import AvatarsPage from "./display/AvatarsPage.mdx"
import CardsPage from "./display/CardsPage.mdx"
import CodePage from "./display/CodePage.mdx"
import LabelsPage from "./display/LabelsPage.mdx"
import LoadingPage from "./display/LoadingPage.mdx"
import ListsPage from "./display/ListsPage.mdx"
import MessagesPage from "./display/MessagesPage.mdx"
import ModalsPage from "./display/ModalsPage.mdx"
import ProgressPage from "./display/ProgressPage.mdx"
import TablesPage from "./display/TablesPage.mdx"
import TooltipsPage from "./display/TooltipsPage.mdx"

import Cognition from "./accessibility/Cognition.mdx"
import Vision from "./accessibility/Vision.mdx"

interface Page {
  component: ComponentType<any>
  title: string
  route: string
  beta?: boolean
}

interface Section {
  title: string
  route: string
  items: Page[]
}

export const routes: Section[] = [
  {
    title: "Base Elements",
    route: "base",
    items: [
      {
        title: "Aspect Ratios",
        route: "aspect-ratios",
        component: AspectRatiosPage,
      },
      { title: "Colors", route: "colors", component: ColorsPage },
      { title: "Dark Mode", route: "dark-mode", component: DarkModePage },
      { title: "Icons", route: "icons", component: IconsPage },
      { title: "Typography", route: "typography", component: TypographyPage },
    ],
  },
  {
    title: "Control Components",
    route: "controls",
    items: [
      { title: "Buttons", route: "buttons", component: ButtonsPage },
      {
        title: "Date Fields",
        route: "dates",
        component: DateFieldsPage,
        beta: true,
      },
      {
        title: "File Fields",
        route: "files",
        component: FileFieldsPage,
        beta: true,
      },
      {
        title: "Input Fields",
        route: "input-fields",
        component: InputFieldsPage,
      },
      { title: "Navigation", route: "navigation", component: NavigationPage },
      {
        title: "Dropdowns",
        route: "dropdowns",
        component: DropdownsPage,
        beta: true,
      },
      { title: "Tabs", route: "tabs", component: TabsPage },
      { title: "Toggles", route: "toggles", component: TogglesPage },
    ],
  },
  {
    title: "Display Components",
    route: "display",
    items: [
      { title: "Avatars", route: "avatars", component: AvatarsPage },
      { title: "Cards", route: "cards", component: CardsPage },
      { title: "Code", route: "code", component: CodePage },
      { title: "Labels", route: "labels", component: LabelsPage },
      { title: "Loading", route: "loading", component: LoadingPage },
      { title: "Lists", route: "lists", component: ListsPage },
      { title: "Messages", route: "messages", component: MessagesPage },
      { title: "Modals", route: "modals", component: ModalsPage },
      {
        title: "Progress Steppers",
        route: "progress",
        component: ProgressPage,
      },
      { title: "Tables", route: "tables", component: TablesPage },
      { title: "Tooltips", route: "tooltips", component: TooltipsPage },
    ],
  },
  {
    title: "Accessibility",
    route: "accessibility",
    items: [
      {
        title: "Cognition & Comprehension",
        route: "cognition",
        component: Cognition,
      },
      { title: "Vision", route: "vision", component: Vision },
    ],
  },
]
